import {Locale} from '@/utils/constants'
import {DEFAULT_HOST} from '@/utils/router'

import {getImageLocale} from '../utils/helpers'

export const getTmAcademyContent = (locale: Locale) => {
  const ogImageLocale = getImageLocale(locale)

  return {
    metaTitle: 'tm-academy-meta-title',
    metaDescription: 'tm-academy-meta-desc',
    ogImage: {
      url: `${DEFAULT_HOST}/images/og-images/trademark-academy-${ogImageLocale}.png`,
      width: 1200,
      height: 627,
      alt: 'Trademark academy - OG image',
    },
    header: {
      academyLinkText: 'tm-academy-header-title',
      trySearchingForTitle: 'try-searching-for',
      noResultsTitle: 'no-results-found',
      searchPlaceholder: 'search-text',
      buttonLinkText: 'tm-academy-header-cta-button',
    },
    hero: {
      title: 'tm-academy-hero-title',
      subtitle: 'tm-academy-hero-subtitle',
      buttonLinkText: 'tm-academy-hero-button',
      imageSrc: '/images/hero/academy.svg',
      imageAlt: 'Reading a book',
    },
    topics: {
      title: 'tm-academy-topics-title',
    },
    endorsers: {
      title: 'tm-academy-endorsers-title',
      list: [
        {
          imageSrc: '/images/partners/eagle-labs-logo.svg',
          imageAlt: 'Eagle Labs logo',
          linkHref: 'https://labs.uk.barclays',
        },
        {
          imageSrc: '/images/partners/vacuumlabs-logo-dark.svg',
          imageAlt: 'Vacuumlabs logo',
          linkHref: 'https://vacuumlabs.com',
        },
        {
          imageSrc: '/images/partners/shoptet-logo.svg',
          imageAlt: 'Shoptet logo',
          linkHref: 'https://www.shoptet.sk',
        },
        {
          imageSrc: '/images/partners/verdikto-logo.svg',
          imageAlt: 'Verdikto logo',
          linkHref: 'https://www.verdikto.com',
        },
        {
          imageSrc: '/images/partners/sparring-logo.svg',
          imageAlt: 'Sparring logo',
          linkHref: 'https://sparring.io',
        },
      ],
    },
    topicsTitle: 'tm-academy-sidebar-topics-title',
  }
}
